import React from "react";

export default function BankChargesPage() {

  return (
    <div>

      <div className="page-header">
        <h1>Bank Charges</h1>
      </div>

      <div className="card">

        <table>

          <thead>
            <tr>
              <th>Mode</th>
              <th>Charge</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>IMPS</td>
              <td>₹5</td>
            </tr>

            <tr>
              <td>NEFT</td>
              <td>₹3</td>
            </tr>

            <tr>
              <td>RTGS</td>
              <td>₹10</td>
            </tr>
          </tbody>

        </table>

      </div>

    </div>
  );
}